/**
 * The storefront templates an environment can choose (`storefront_configs.storefront_template`):
 * the layout of the storefront's templated pages, the home page and the boxes page. The storefront
 * implements one per id (`STOREFRONT_TEMPLATES`, checked against this list), and the dashboard's
 * Template page offers them.
 */
import { z } from "zod";

export const STOREFRONT_TEMPLATE_IDS = ["classic"] as const;
export type StorefrontTemplateId = (typeof STOREFRONT_TEMPLATE_IDS)[number];

export const storefrontTemplateIdSchema = z.enum(STOREFRONT_TEMPLATE_IDS);

/** What an environment renders until an editor picks another. */
export const DEFAULT_STOREFRONT_TEMPLATE_ID: StorefrontTemplateId = "classic";

/** Each template's name and one-line description, as the dashboard shows them. */
export const STOREFRONT_TEMPLATE_INFO: Record<
  StorefrontTemplateId,
  { label: string; description: string }
> = {
  classic: {
    label: "Classic",
    description:
      "A hero, three promo cards, the shopper's best recent opens, the featured boxes and an FAQ on the home page; tabs and filters over the best opens and a grid on the boxes page.",
  },
};
